import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import { ConversationDetail } from '../../core/src/lib/interface/conversation.interface';
dayjs.extend(calendar);

@Pipe({ name: 'timestamp' })
export class TimestampsPipe implements PipeTransform {
  transform(conversationDetail: ConversationDetail): string {
    const timestamp = conversationDetail?.conversation?.latestMsgSentTime;
    const sameDay = timestamp ? dayjs().isSame(timestamp, 'day') : false;
    return sameDay ? dayjs(timestamp).format('h:mm A') : dayjs(timestamp).format('MMM D');
  }
}

@Pipe({ name: 'messageTime' })
export class MessageTime implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}
  transform(messageTime: Date): string {
    const today = this.translateService.instant('INBOX.DATE.TODAY');
    const yesterday = this.translateService.instant('INBOX.DATE.YESTERDAY');
    const at = this.translateService.instant('INBOX.DATE.AT');
    return dayjs(messageTime).calendar(new Date(), {
      sameDay: `[${today}] h:mm A`, // The same day ( Today 2:30 AM )
      lastDay: `[${yesterday}] h:mm A`, // The day before ( Yesterday 2:30 AM )
      lastWeek: `ddd, MMM D [${at}] h:mm A`, // lastWeek should also follow format ( Mon, Apr 12 at 2:30 AM )
      sameElse: `ddd, MMM D [${at}] h:mm A`, // Everything else (Mon, Apr 12 at 2:30 AM )
    });
  }
}
